import React from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import { generateRedux } from "components/InfinityTable/Redux"
import CustomsList from "components/CustomsList"

export const redux = generateRedux({
  id: "containers/CustomsList/",
  url: "/api/customs",
  initialState: {
    sortableColumns: ["id", "articleNumber", "description", "tariffNumber"]
  },
  sagas: []
})

const connectRedux = connect(
  createStructuredSelector({
    ...redux.structuredSelector
    // additional selectors here
  }),
  {
    ...redux.actions
  }
)

const Customs = props => {
  return <CustomsList {...props} />
}

export default connectRedux(Customs)
